export default "__VITE_ASSET__5d63444d__"